export default {
  initialize(owner) {
    owner.lookup("service:client-error-handler");
  },
};
